var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(-1049 -395)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_144",
    "data-name": "Ellipse 144",
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    transform: "translate(1049 395)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375",
    transform: "translate(1062.5 402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M24.1,17.9l-6.2,6.2a.608.608,0,0,1-.8,0L.8,7.8a.967.967,0,0,1,0-1.4L6.4.8A.967.967,0,0,1,7.8.8L24.1,17.1A.468.468,0,0,1,24.1,17.9Z",
    fill: "none",
    stroke: "#e0611a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M24.7,24a.472.472,0,0,1-.5.5l-6.362-.1a.058.058,0,0,1-.04-.1l6.661-6.563c.016-.015.042-.01.043.011L24.7,24",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M24.7,24a.472.472,0,0,1-.5.5l-6.362-.1a.058.058,0,0,1-.04-.1l6.661-6.563c.016-.015.042-.01.043.011Z",
    fill: "none",
    stroke: "#e0611a",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_114",
    "data-name": "Line 114",
    y1: 7,
    x2: 7,
    transform: "translate(4.7 4.6)",
    fill: "none",
    stroke: "#e0611a",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("text", {
    id: "Edit-2",
    "data-name": "Edit",
    transform: "translate(1075 439)",
    fill: "#e0611a",
    fontSize: 10,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8,
    y: 0
  }, "Edit")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e3e4969a54072f47762faf9cd7366fac.svg";
export { ForwardRef as ReactComponent };